import styled from "styled-components";

export const BreadcrumbsContainer = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 12px 0;
  font-size: 14px;
`;

export const BreadcrumbLink = styled.span`
  color: #666;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #1976d2;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export const BreadcrumbSeparator = styled.span`
  color: #bbb;
  margin: 0 2px;
  font-size: 12px;
`;

export const BreadcrumbCurrent = styled.span`
  color: #333;
  font-weight: 500;
`;
